import type IdentityProviderView from '@UI/Store/Sso/Views/IdentityProviderView';
import * as React from 'react';
import { Message } from '@verclam/ui-kit';

type Props = {
	readonly identityProvider: IdentityProviderView | null;
};

/**
 * Announces what the persisted configuration implies for users: saved but inactive, password closed
 * (exclusive mode), or the second factor delegated to the identity provider. Reads the persisted
 * configuration, never the form: these banners describe what is actually in effect today, not what an
 * in-progress edit is about to become.
 */
const IdentityProviderStatusMessages: React.FC<Props> = ({ identityProvider }) => {
	return (
		<React.Fragment>
			{identityProvider !== null && !identityProvider.isEnabled ? (
				<Message
					severity="info"
					text="Cette configuration est enregistrée mais inactive. Personne ne peut se connecter par le fournisseur d’identité tant qu’elle n’est pas activée."
				/>
			) : null}
			{identityProvider?.isEnabled && identityProvider.isExclusive ? (
				<Message
					severity="warn"
					text="Le mot de passe est fermé pour cette structure. Si le fournisseur d’identité devient indisponible, plus personne ne pourra se connecter — y compris vous. Le rétablissement passe alors par un contact avec l’éditeur."
				/>
			) : null}
			{identityProvider !== null ? (
				<Message
					severity="info"
					text="Le second facteur est géré par votre fournisseur d’identité. Les comptes connectés par SSO n’utilisent pas le second facteur de Dixit."
				/>
			) : null}
		</React.Fragment>
	);
};

export default IdentityProviderStatusMessages;
